import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { empty } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-catalogs-catalog-devices-staff-card',
  templateUrl: './catalogs-catalog-devices-staff-card.component.html',
  styleUrls: ['./catalogs-catalog-devices-staff-card.component.scss']
})
export class CatalogsCatalogDevicesStaffCardComponent implements OnInit, OnDestroy {

  @Input() catalog: CatalogBasic;
  @Input() staffDevices;
  selectedDevices;
  updateCatalogDevicesStaffSubscription: Subscription;
  updateCatalogPrintInmediatelySubscription: Subscription;
  getCatalogDevicesSubscription: Subscription;
  basicDataForm = new FormGroup({
    printInmediately: new FormControl(null, Validators.required)
  });

  constructor(private catalogsService: CatalogsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.resetForm();
  }

  public duallistboxOutputEventReceiver(selectedDevices) {
    const aux = new Array();
    for (const d of selectedDevices) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDevices = aux;
      this.updateCatalogDevices(this.getDevicesInternalIds(this.selectedDevices));
    }
  }

  public updateCatalogDevices(devicesInternalIds) {
    this.updateCatalogDevicesStaffSubscription = this.catalogsService.updateCatalogDevicesStaff(this.catalog.InternalId, devicesInternalIds).pipe(
      tap(o => this.catalogsService.refreshCatalog()),
      tap(o => this.snackbarService.open('catalogs-page.snackbar messages.update catalog success', 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  public updateCatalogPrintInmediately() {
    this.updateCatalogPrintInmediatelySubscription = this.catalogsService.updateCatalogPrintInmediately(this.catalog.InternalId, this.basicDataForm.get('printInmediately').value).pipe(
      tap(o => this.catalogsService.refreshCatalog()),
      tap(o => this.snackbarService.open('catalogs-page.snackbar messages.update catalog success', 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private getDevicesInternalIds(devices) {
    if (devices) {
      return devices.map(d => d.InternalId);
    }
    return [];
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      printInmediately: this.catalog.PrintInmediately
    });
  }

  ngOnDestroy() {
    if (this.updateCatalogDevicesStaffSubscription) { this.updateCatalogDevicesStaffSubscription.unsubscribe(); }
    if (this.getCatalogDevicesSubscription) { this.getCatalogDevicesSubscription.unsubscribe(); }
  }

}
